<div fxFlex="100" >
    <button mat-stroked-button color="secundary" (click)="dimiss()">Fechar</button>
    <ngx-extended-pdf-viewer [base64Src]="data" enablePrintAutoRotate="true" [printResolution]="300" [showUnverifiedSignatures]="true" [showHandToolButton]="true" useBrowserLocale="true" height="90vh" [zoom]="'page-width'">
    </ngx-extended-pdf-viewer>
</div>
